/**
 * Barrel for the blog's Contentful rich-text renderers: the node type they walk, the mark
 * components, {@link renderBlogText} (article bodies) and {@link renderSimpleText} (category
 * callouts). These render the already-resolved JSON tree that `@ryerson/frontend.contentful` →
 * `Crawl` returns with `resolveRichText: true`, not the `raw` string that
 * `components/Shared/model/Contentful.tsx` renders for the other areas.
 */

/**
 * One node of a resolved Contentful rich-text document, as `Crawl` delivers it.
 *
 * - `nodeType`: the Contentful node type (`document`, `paragraph`, `heading-2`, `text`,
 *   `hyperlink`, `embedded-entry-inline`, …). The renderers switch on it.
 * - `data`: per-node payload. For `hyperlink` it holds `uri`. For embedded entries and assets
 *   `Crawl` replaces `data.target` (a link) with the linked entry's or asset's fields.
 * - `value` and `marks`: set on `text` nodes only; `marks` holds `bold`, `italic`, `underline` or
 *   `code`.
 * - `entryType`: set by `Crawl` on embedded entries to the linked entry's content-type id
 *   (`blogVideo`, `blogButton`, …). Absent on plain nodes and assets.
 */
export type RichTextNode = {
	nodeType: string;
	data: any;
	content?: RichTextNode[];
	value?: string;
	marks?: { type: string }[];
	entryType?: string;
};

export { Bold, Text, Italic, Underline } from "./shared";

export { renderBlogText } from "./Blog";
export { renderSimpleText } from "./Simple";
